import { Loader } from "@googlemaps/js-api-loader"

window.addEventListener("load", function(){
    
    
    var classname = document.querySelectorAll(".cb-map-block");

    if( classname.length ){
    
        const loader = new Loader({
            apiKey: theme.google_maps,
            version: "weekly",
        });

        loader.load().then(() => {

            for (var i = 0; i < classname.length; i++) {
    
           
                 // Generate 
                let id = classname[i].getAttribute('id');

                let lat = classname[i].getAttribute('data-lat');
                let lng = classname[i].getAttribute('data-lng');
                let zoom = classname[i].getAttribute('data-zoom');
                let icon = classname[i].getAttribute('data-icon');

                let map = new google.maps.Map( document.getElementById( id ) , {
                  center: { lat: Number(lat), lng: Number(lng) },
                  zoom: Number(zoom),
                });

                if( icon ){

                const features = [
                    {
                      position: new google.maps.LatLng(lat, lng),
                      type: "info",
                    }

                  ];
                  let _icon = {
                    url: icon, // url
                    scaledSize: new google.maps.Size(75, 75), // scaled size
                    origin: new google.maps.Point(0,0), // origin
                    anchor: new google.maps.Point(37.5, 75) // anchor
                };
                
                    features.forEach((feature) => {
                        new google.maps.Marker({
                            position: feature.position,
                            icon: _icon,
                            map: map,
                        });
                    });

                }


            }

        });

    }
        
    
});